import React, { useContext } from 'react'
import { LanguageContext } from '../../context'
import ReactGoogleAutocomplete from "react-google-autocomplete"

const AddressInput = ({ onChange, value, disabled, className, id }) => {
  const { t } = useContext(LanguageContext)
  const handleChange = (place) => {
    console.log(place)
    // street: string,
    // number: string,
    // city: string,
    // zip: string,
    // country: string,
    const address = {
      formatted: place.formatted_address,
      street: place.address_components.find(c => c.types.includes("route"))?.long_name || "",
      number: place.address_components.find(c => (c.types.includes("street_number") || c.types.includes("premise")))?.long_name || "",
      city: place.address_components.find(c => (c.types.includes("locality") || c.types.includes("sublocality")))?.long_name || "",
      zip: place.address_components.find(c => c.types.includes("postal_code"))?.long_name || "",
      country: place.address_components.find(c => c.types.includes("country"))?.long_name || ""
    }
    onChange({
      target: {
        name: "address",
        value: address
      }
    })
  }

  return (
    <ReactGoogleAutocomplete
      disabled={disabled}
      apiKey={"AIzaSyA35JdkO8SR7Vz1nw2VjRDU3Knhjq9F_Oc"}
      onPlaceSelected={handleChange}
      options={{types: ["address"], fields: ["formatted_address", "address_components"]}}
      defaultValue={value?.formatted || ''}
      className={`pac-target-input ${className || ''}`}
      id={id}
      placeholder={t('address_input.placeholder')}
    />
  )
}

export default AddressInput
